// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_recommendation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assistantRecommendationKindValues, assistantRecommendationStateValues } from '@borradh-workspace/labels';
/** Response atom for the "assistant_recommendation" table (1:1 with a DB row, on the wire). */
export const assistantRecommendationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    kind: z.enum(assistantRecommendationKindValues),
    title: z.string(),
    body: z.string(),
    primaryAction: z.unknown(),
    state: z.enum(assistantRecommendationStateValues),
    priority: z.number(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    actionedAt: z.string().datetime().nullable(),
    dismissedAt: z.string().datetime().nullable(),
    expiresAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=assistantRecommendation.js.map